import React from 'react';
import LandingContext from './LandingContext';

export default function useLanding() {
    return React.useContext(LandingContext);;
}
